/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserConditionDto = {
  type: UserConditionDto.type;
  /**
   * 가입일 시작 (ISO8601)
   */
  signupDateFrom?: string;
  /**
   * 가입일 종료 (ISO8601)
   */
  signupDateTo?: string;
  platform?: UserConditionDto.platform;
  loginProvider?: UserConditionDto.loginProvider;
  contentPackId?: string;
  /**
   * 스터디그룹 spaceId
   */
  studyGroupId?: string;
};
export namespace UserConditionDto {
  export enum type {
    SIGNUP_DATE = "signupDate",
    PLATFORM = "platform",
    LOGIN_PROVIDER = "loginProvider",
    CLEARED_CONTENT_PACK = "clearedContentPack",
    STUDY_GROUP = "studyGroup",
  }
  export enum platform {
    IOS = "ios",
    ANDROID = "android",
    WEB = "web",
  }
  export enum loginProvider {
    EMAIL = "email",
    KAKAO = "kakao",
    APPLE = "apple",
  }
}
